import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Contact from "./pages/Contact";
import Cart from "./pages/Cart";
import PaymentReturn from "./pages/PaymentReturn";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/toaster";
import { CartProvider } from "./context/CartContext";

function App() {
  return (
    <div className="App">
      <CartProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/onze-luchtkastelen" element={<Products />} />
            <Route path="/onze-luchtkastelen/:slug" element={<ProductDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/winkelwagen" element={<Cart />} />
            <Route path="/betaling/:status" element={<PaymentReturn />} />
            {/* Old standalone pages now live on the one-pager */}
            <Route path="/over-ons" element={<Navigate to="/#over-ons" replace />} />
            <Route path="/evenementen" element={<Navigate to="/#evenementen" replace />} />
            <Route path="/faq" element={<Navigate to="/#faq" replace />} />
          </Route>
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
      </CartProvider>
    </div>
  );
}

export default App;
